import Keycloak from 'keycloak-js'
import { config } from '~/config'

const { authUrl, authRealm, authClient } = config

export const keyCloakInstance = new Keycloak({
  url: authUrl,
  realm: authRealm,
  clientId: authClient,
})
